export default "/assets/FCLLogo.png";